import React, {Component, useState, useEffect} from 'react';
import {  Link } from 'react-router-dom';
import axios from 'axios';
import { globalConfig } from '../../config/config'
import { toast } from 'react-toastify';

const initialState = {
    transformations: []
}
const Transformers = () => 
{

  const [search, setSearch] = useState("");
  const [transformations, setTransformations]  = useState([]);

	const handleOnLoad = () => {
      axios.get(`${globalConfig.apiDatahubUrl}/transformations/`, globalConfig.hardcoded_header).then(res => {
      const transformations = res.data;
      setTransformations(transformations);
      toast.success("Loaded " + transformations.length + " transformers.");
		});
		
	}
	const	handleFilter = (e) => {
		try
		{

    let URL = `${globalConfig.apiDatahubUrl}/transformations?`;
    URL += `&filter[where][or][0][transformationName][regexp]=/(${search})/i&filter[where][or][1][description][regexp]=/(${search})/i`;
    axios.get(URL, globalConfig.hardcoded_header).then((res) => {
      const filteredTransformers = res.data;
      setTransformations(filteredTransformers);
      toast.success("Filtered " + transformations.length + " transformers.");
    });
    }
    catch(x)
    {
    	toast.error("An error occurred while filtering your search - please try again.");
    }

	}
	
	const handleDelete = (e, id) => {
		if (id > 0)
		{
			try {
			      axios.delete(`${globalConfig.apiDatahubUrl}/transformations/${id}`, globalConfig.hardcoded_header)
			      	.then(res => {
						toast.success("Successfully deleted the transformer.");
					})
					.catch(err => {
						if (err.response)
						{
							toast.error("Failed to delete the transformer - " + err.response.status);
						}
					})
			}
			catch(x) {
				toast.error("Failed to delete the transfomer.");
			}
			toast.success("Successfully deleted the transformer.");
			handleOnLoad();
		}
		else {
			toast.error("Invalid identifier for your selection - cannot delete.");
		}
	}

	useEffect(() => 
	{
		handleOnLoad();
	}, []);	

    return (
		<form>
		<div class="container-fluid">

	<div className="d-flex flex-row justify-content-between mb-3 mt-3">
			  <h4>Transformations</h4>
			  <div>
            <Link to="/neo/create-transformer" className="btn-success btn">
              Create Transformer
            </Link>
            &nbsp;
            <Link to="/" className="btn-primary btn">
              Home
            </Link>
            &nbsp;
            <Link to="/neo" className="btn-warning btn">
              Back
            </Link>
            </div>
      </div>



          <div class="form-group">
            <input
              className="form-control"
              value={search}
              onChange={(e) => {setSearch(e.target.value);handleFilter(e.target.value)}}
              type="search"
              id="transformationSearchString"
              placeholder="Search"
            />
          </div>


      <div className="form-group row">


      	<table class="table table-bordered table-striped">
      	<thead>
      	<tr>
      	<th scope="col">#</th>
      	<th scope="col">Name</th>
     	<th scope="col">Description</th>
     	<th scope="col">Action</th>
    	</tr>
  		</thead>
  		<tbody>

          {transformations.map( ( {transformationName, transformationTypeCode, description, transformationId} ) => {
  					  return <tr>
  					  	
  					  	<td class="ContentTitle">
                          <Link
                            to={{
                              pathname: `/neo/manage-transformer/${transformationId}`,
                            }}
                          >
                            {transformationId}{" "}
                          </Link>
                        </td>
                        <td class="ContentTitle">
                          <Link
                            to={{
                              pathname: `/neo/manage-transformer/${transformationId}`,
                            }}
                          >
                            {transformationName}{" "}
                          </Link>
                        </td>
                        <td class="ContentTitle">
                          <Link
                            to={{
                              pathname: `/neo/manage-transformer/${transformationId}`,
                            }}
                          >
                            {description}
                          </Link>
                        </td>

  					  	
  					  	<td>
  					  		<Link>
  					  		<button class="btn btn-danger"
  					  			onClick={(e) => handleDelete(e, transformationId)}
  					  		>
  					  			Delete
  					  		</button>
  					  		</Link>
  					  	</td>
  					  	</tr>
					}) 
				}
        </tbody>
        </table>
      </div>
      </div>
		</form>		
	  );

}

export default Transformers;